<div class="table-responsive" [class.overflow-hidden]="serviceRequestService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover table footable">
        <thead>
            <tr [ngClass]="{'noSort': serviceRequestService.data.allServiceRequests.data.length < 2}">
                <th></th>
                <th (click)="orderBy('priority', $event)">
                    Priority <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('serviceRequestNumber', $event)">
                    ID <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="serviceRequestService.buildings.length > 1 && !authenticationService.userIsResident"
                    (click)="orderBy('building.name', $event)">
                    Building <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!authenticationService.userIsResident" (click)="orderBy('suite', $event)">
                    Unit <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('serviceRequestType.name', $event)">
                    Type <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!serviceRequestService.showDetailedView"
                    (click)="orderBy('createdAt', $event)"
                    class="footable-sorted-desc">
                    Created On <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!serviceRequestService.showDetailedView" (click)="orderBy('createdBy.fullName', $event)">
                    Created By <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('serviceRequestWorkerContract', $event)"
                    *ngIf="!serviceRequestService.showDetailedView">
                    Assigned To <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('status', $event)">
                    Status <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('updatedAt', $event)" *ngIf="!serviceRequestService.showDetailedView">
                    Last Updated <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="serviceRequestService.canEdit() &&!serviceRequestService.showDetailedView">
                    Actions
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="serviceRequestService.data.allServiceRequests.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td class="text-capitalize"
                        [ngStyle]="{color: item.priority =='urgent' ? 'red' : ''}"
                        [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>Priority</span>
                        </div>
                        <span>{{item.priority}}</span>
                    </td>
                    <td [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>ID</span>
                        </div>
                        <span>{{item.serviceRequestNumber}}</span>
                    </td>
                    <td *ngIf="serviceRequestService.buildings.length > 1 && !authenticationService.userIsResident"
                        [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>Building</span>
                        </div>
                        <span>{{item.buildingName}}</span>
                    </td>
                    <td *ngIf="!authenticationService.userIsResident" [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>Unit</span>
                        </div>
                        <span>{{item.suiteNumber}}</span>
                    </td>
                    <td [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>Type</span>
                        </div>
                        <span>
                            {{item.serviceRequestType.name ? item.serviceRequestType.name : item.serviceRequestTypeOther}}
                        </span>
                    </td>
                    <td *ngIf="!serviceRequestService.showDetailedView" [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>Created On</span>
                        </div>
                        <span>{{item.createdAt | mccDate:false:true}}</span>
                    </td>
                    <td *ngIf="!serviceRequestService.showDetailedView" [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>Created By</span>
                        </div>
                        <span>{{item.createdByFullName}}</span>
                    </td>
                    <td *ngIf="!serviceRequestService.showDetailedView" [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>Assigned To</span>
                        </div>
                        <span>
                            {{item.assigneeName}}
                        </span>
                    </td>
                    <td [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>Status</span>
                        </div>
                        <div class="table-mobile-right">
                            <span *ngIf="item.status === 'open'" class="text-uppercase label label-open">
                                Open
                            </span>
                            <span *ngIf="item.status === 'in_progress'" class="text-uppercase label label-in-progress">
                                In Progress
                            </span>
                            <span *ngIf="item.status === 'on_hold'" class="text-uppercase label label-on-hold">
                                On Hold
                            </span>
                            <span *ngIf="item.status === 'closed'" class="text-uppercase label label-closed">
                                Closed
                            </span>
                            <span *ngIf="item.status === 'archived'" class="text-uppercase label label-archived">
                                Archived
                            </span>
                            <span *ngIf="item.status === 'cancelled'" class="text-uppercase label label-cancelled">
                                Cancelled
                            </span>
                        </div>
                    </td>
                    <td *ngIf="!serviceRequestService.showDetailedView" [ngClass]="{'bold-text' : !item.isRead}">
                        <div class="table-mobile-left">
                            <span>Last Updated</span>
                        </div>
                        <span>{{item.updatedAt | mccDate:false:true}}</span>
                    </td>
                    <td class="td-action-btn"
                        *ngIf="serviceRequestService.canEdit() && !serviceRequestService.showDetailedView">
                        <div class="input-group-btn btn-in-table input-group"
                             (click)="$event.showDropdown = true;"
                             *ngIf="!authenticationService.userIsResident">
                            <button (click)="changeServiceRequestReadStatus($event, 1, item)"
                                    *ngIf="item.status === 'open' && !item.isRead"
                                    class="btn btn-white btn-xs same-button-width">
                                Mark as Read
                            </button>
                            <button (click)="assignServiceRequestTo(item, $event)"
                                    *ngIf="item.status === 'open' && item.isRead"
                                    class="btn btn-white btn-xs same-button-width">
                                Assign To
                            </button>
                            <button (click)="changeServiceRequestStatus($event, 'in_progress', item)"
                                    *ngIf="item.status === 'on_hold'"
                                    class="btn btn-white btn-xs same-button-width">
                                Resume
                            </button>
                            <button (click)="changeServiceRequestStatus($event, 'closed', item)"
                                    *ngIf="item.status === 'in_progress'"
                                    class="btn btn-white btn-xs same-button-width">
                                Close
                            </button>
                            <button (click)="changeServiceRequestStatus($event, 'archived', item)"
                                    *ngIf="item.status === 'closed' || item.status === 'cancelled'"
                                    class="btn btn-white btn-xs same-button-width">
                                Archive
                            </button>
                            <button *ngIf="item.status === 'archived'"
                                    (click)="serviceRequestService.getPdf(item)"
                                    class="btn btn-white btn-xs same-button-width">
                                Get PDF
                            </button>
                            <button *ngIf="item.status !== 'archived'"
                                    data-toggle="dropdown"
                                    class="btn btn-white dropdown-toggle btn-xs"
                                    aria-expanded="false">
                                <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu pull-right">
                                <li (click)="changeServiceRequestReadStatus($event, -1, item)">
                                    <a>Add Comment</a>
                                </li>
                                <li (click)="changeServiceRequestReadStatus($event, 1, item)"
                                    *ngIf="item.status !== 'open' && !item.isRead">
                                    <a>Mark as Read</a>
                                </li>
                                <li (click)="changeServiceRequestReadStatus($event, 0, item)" *ngIf="item.isRead">
                                    <a>Mark as Unread</a>
                                </li>
                                <li (click)="assignServiceRequestTo(item, $event)"
                                    *ngIf="!(item.status === 'open' && item.isRead) && item.status !== 'closed' && item.status !== 'cancelled'">
                                    <a>Assign To</a>
                                </li>
                                <li (click)="changeServiceRequestStatus($event, 'on_hold', item)"
                                    *ngIf="item.status !== 'on_hold' && item.status !== 'closed' && item.status !== 'cancelled'">
                                    <a>On Hold</a>
                                </li>
                                <li (click)="changeServiceRequestStatus($event, 'closed', item)"
                                    *ngIf="item.status !== 'in_progress' && item.status !== 'closed' && item.status !== 'cancelled'">
                                    <a>Close</a>
                                </li>
                                <li (click)="changeServiceRequestStatus($event, 'cancelled', item)"
                                    *ngIf="item.status !== 'closed' && item.status !== 'cancelled'">
                                    <a>Cancel</a>
                                </li>
                                <li (click)="changeServiceRequestStatus($event, 'archived', item)"
                                    *ngIf="item.status == 'in_progress' || item.status == 'on_hold'">
                                    <a>Archive</a>
                                </li>
                                <li (click)="serviceRequestService.getPdf(item)">
                                    <a>Get PDF</a>
                                </li>
                            </ul>
                        </div>
                        <div class="input-group-btn btn-in-table input-group"
                             *ngIf="item.status !== 'archived' && item.status !== 'closed' && item.status !== 'cancelled'
                                    && authenticationService.userIsResident && serviceRequestService.residentAccessController(action.commentRead)">
                            <button (click)="changeServiceRequestReadStatus($event, -1, item)"
                                    class="btn btn-white btn-xs same-button-width">
                                Add Comment
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of serviceRequestService.emptyRowService.emptyRow" class="empty-row" style="cursor: default;">
                <td></td>
                <td>&nbsp;</td>
                <td *ngIf="serviceRequestService.buildings.length > 1"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="!serviceRequestService.showDetailedView"></td>
                <td></td>
                <td *ngIf="!serviceRequestService.showDetailedView"></td>
                <td *ngIf="serviceRequestService.canEdit() && !serviceRequestService.showDetailedView"></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!serviceRequestService.data.allServiceRequests.total"
                          [isServiceUnavailable]="serviceRequestService.showServiceUnavailable"
                          [isLoading]="serviceRequestService.spinnerShow">
        You have no service requests listed on the system<br>
        <span *ngIf="serviceRequestService.canEdit()">
            <a href="javascript://" (click)="serviceRequestService.isServiceRequestModalShow = true" class="mtv-primary-color clickable-text">add a new request</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-request-list/service-request-list.component.html